import { Box, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import List, { HeadCell } from 'components/list/list';

import React from 'react';
import StandardOpenSlotRow from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/standard/standard-open-slot-row';
import StandardOrderRow from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/standard/standard-order-row';
import { useOrderRows } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/hooks/use-order-rows';
import { isActiveOrder } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/order-utils';

type Props = { filters: string[] };

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.orders.list';

const StandardOrdersList: FC<Props> = ({ filters }) => {
  const intl = useIntl();
  const theme = useTheme();
  const { rows, isLoading } = useOrderRows(filters);

  const columns: HeadCell[] = [
    {
      id: 'orderStatus',
      align: 'center',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderStatus` }),
    },
    {
      id: 'changes',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.changes` }),
    },
    {
      id: 'dispatchDate',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.dispatchDate` }),
    },
    {
      id: 'deliveryDate',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.deliveryDate` }),
    },
    {
      id: 'quantity',
      align: 'right',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.quantity` }),
    },
    {
      id: 'actions',
      label: '',
      align: 'right',
    },
  ];

  return (
    <>
      <Box display={'flex'} justifyContent={'center'} gap={2} alignItems={'center'}>
        <Typography>
          <FormattedMessage id={`${PAGE_NAME_ID}.manual`} />
        </Typography>
        <Box borderBottom={`1px solid ${theme.palette.darkBlue.o25}`} width={'100%'} />
      </Box>
      <List
        options={columns}
        isLoading={isLoading}
        noResult={{
          show: !rows.length,
          text: intl.formatMessage({ id: `general.noResults` }),
        }}>
        {rows.map((row, idx) =>
          isActiveOrder(row) ? <StandardOrderRow key={idx} order={row} /> : <StandardOpenSlotRow key={idx} openSlot={row} />
        )}
      </List>
    </>
  );
};

export default React.memo(StandardOrdersList);
